import { render, staticRenderFns } from "./CookiesBar.vue?vue&type=template&id=5889da2b&"
import script from "./CookiesBar.vue?vue&type=script&lang=js&"
export * from "./CookiesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports